import { faCheck } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Tooltip, UnstyledButton } from '@mantine/core';
import { useTranslation } from 'react-i18next';

type ClosePropsType = {
  onClick: () => void;
};

export const Close: React.FC<ClosePropsType> = ({ onClick }) => {
  const { t } = useTranslation('common');

  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();
    onClick();
  };

  const label = t('ACTIONS.CLOSE');

  return (
    <Tooltip label={label}>
      <UnstyledButton onClick={handleClick} aria-label={label}>
        <FontAwesomeIcon icon={faCheck} />
      </UnstyledButton>
    </Tooltip>
  );
};
